import './App.css';
import { BrowserRouter as Router, Routes, Route }
    from 'react-router-dom';
import SignInScreen from './pages/SignInScreen';
import Authenticate from './pages/Authenticate';
import Portal from './pages/Portal';
import Meeting from './pages/Meeting';
import FitDemographics from './pages/FitDemographics';
import FitRecruitment from './pages/FitRecruitment';
import FitThankYou from './pages/FitThankYou';
import FitOnboardingDashboard from './pages/FitOnboardingDashboard'
import FitVerification from './pages/FitVerification'
import FitOnboard from './pages/FitOnboard';
import FitWelcome from './pages/FitWelcome';
import FitOnboardedDashboard from './pages/FitOnboardedDashboard';
import FitSocialSupportOnboard from './pages/FitSocialSupportOnboard';
import FitSupportWelcome from './pages/FitSupportWelcome';
import FitAdminDashboard from './pages/FitAdminDashboard'
function App() {
  return (
    <Router>
      <Routes>
          <Route exact path='/'  element={<SignInScreen />} />
          <Route path="Authenticate" element={<Authenticate />} />
          <Route path="Portal" element={<Portal />} />
          <Route path="Meeting" element={<Meeting />} />
          <Route path="FitRecruitment" element={<FitRecruitment />} />
          <Route path="FitThankYou" element={<FitThankYou />} />
          <Route path ="FitOnboardingDashboard" element={<FitOnboardingDashboard />} />
          <Route path="FitVerification" element={<FitVerification />} />
          <Route path="FitOnboard" element={<FitOnboard />} />
          <Route path="FitWelcome" element={<FitWelcome />} />
          <Route path="FitDemographics" element={<FitDemographics />} />
          <Route path="FitAdminDashboard" element={<FitAdminDashboard />} />
          <Route path="FitOnboardedDashboard" element={<FitOnboardedDashboard />} />
          <Route path="FitSocialSupportOnboard" element={<FitSocialSupportOnboard />} />
          <Route path="FitSupportWelcome" element={<FitSupportWelcome />} />
      </Routes>
    </Router> 
  );
}

export default App;
